// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!components/ui/common.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._39f1e5{}._66394f{font-size:calc(var(--scale)*1.33em);color:var(--primary);line-height:1.75}._66394f:after,._66394f:before{content:\"“\"}._09d332{color:var(--secondary);text-align:right}", ""]);
// Exports
exports.locals = {
	"quote": "_39f1e5 " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["medium-spacing"] + "",
	"text": "_66394f",
	"author": "_09d332"
};
module.exports = exports;
